var map = {
	"./A99A.png": 8147,
	"./arrow.png": 2798,
	"./banner-iphone.png": 3730,
	"./brand.png": 2593,
	"./cart-active-bg.png": 9971,
	"./cart-active.png": 4542,
	"./cart.png": 1648,
	"./category-active-bg.png": 1541,
	"./category-active.png": 944,
	"./category.png": 3793,
	"./code-logo.png": 727,
	"./code.png": 6259,
	"./customer.png": 8419,
	"./future.png": 513,
	"./home.png": 6553,
	"./hotsign.png": 4787,
	"./index-active-bg.png": 5392,
	"./index-active.png": 3843,
	"./index.png": 179,
	"./iphone.png": 7205,
	"./kefu.png": 4311,
	"./logo.png": 6949,
	"./message.png": 8050,
	"./my-active-bg.png": 7733,
	"./my-active.png": 2723,
	"./my.png": 2231,
	"./qq.png": 348,
	"./serve.png": 7516,
	"./title-bg.png": 6052,
	"./wechat-code.png": 4349,
	"./wechat.png": 1157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;